import { Controller } from '@hotwired/stimulus'
import useI18n from '@app/shared/vue/composables/use-I18n'

export default class extends Controller {
  static I18n = useI18n()

  toggleBillCalculationDetails(event: Event): void {
    if (!event || !event.currentTarget) return
    const toggle = event.currentTarget as HTMLElement
    if (!toggle) return
    event.preventDefault()

    const content = this.findToggledBlock(toggle)
    if (!content) return

    const HIDE_DETAILS_CLASS = 'sf-hidden'
    content.classList.toggle(HIDE_DETAILS_CLASS)
    if (content.classList.contains(HIDE_DETAILS_CLASS)) {
      this.showShowDetailsToggle(toggle)
    } else {
      this.showHideDetailsToggle(toggle)
    }
  }
  showShowDetailsToggle(toggle: HTMLElement): void {
    if (!this.toggleToggleIcon(toggle)) {
      toggle.textContent = useI18n().t('firms.internal_invoices.show_details')
    }
  }

  showHideDetailsToggle(toggle: HTMLElement): void {
    if (!this.toggleToggleIcon(toggle)) {
      toggle.textContent = useI18n().t('firms.internal_invoices.hide_details')
    }
  }

  toggleToggleIcon(toggle: HTMLElement): boolean {
    const TOGGLE_TWIN_CLASS = 'bill-calc-toggle-twin'
    const HIDE_DETAILS_CLASS = 'sf-hidden'
    if (toggle.classList.contains(TOGGLE_TWIN_CLASS)) {
      toggle.classList.toggle(HIDE_DETAILS_CLASS)
      if (toggle.nextElementSibling) {
        toggle.nextElementSibling.classList.toggle(HIDE_DETAILS_CLASS)
      } else if (toggle.previousElementSibling) {
        toggle.previousElementSibling.classList.toggle(HIDE_DETAILS_CLASS)
      }
      return true
    } else {
      return false
    }
  }

  findToggledBlock(toggle: HTMLElement | null): HTMLElement | null {
    const TOGGLED_BLOCK_CLASS = 'bill-calc'
    if (!toggle) return null
    let parent = toggle.parentElement
    let target = parent ? (parent.nextElementSibling as HTMLElement) : null

    while (!target || !target.classList.contains(TOGGLED_BLOCK_CLASS)) {
      if (target) target = target.nextElementSibling as HTMLElement
      else {
        parent = parent ? parent.parentElement : null
        if (parent) target = parent.nextElementSibling as HTMLElement
        else break
      }
    }

    if (target && target.classList.contains(TOGGLED_BLOCK_CLASS)) return target
    return null
  }
}
